import { StyledFlexConteiner } from "./StyledComponents/Containers";
import { BackgroundEnum } from "../Enums/ThemeEnums";
import styled from "styled-components";

export let StyledDropdown = styled(StyledFlexConteiner).attrs(() => ({
  jc: "space-between",
  align_items: "center",
  margin: "20px 0px",
  height: "40px",
}))<{ $is_menu_active: boolean }>`
  position: relative;

  & > button {
    box-shadow: none;
  }

  & > menu {
    position: absolute;
    inset: 0px 0px auto auto;
    transform: translate(0px, 50px);

    margin: 0px;
    padding: 5px 0px;

    background-color: ${BackgroundEnum.white};

    border: solid 1px;
    border-radius: 5px;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15),
      0 6px 40px 0 rgba(0, 0, 0, 0.15);
    z-index: 10;

    max-width: 200px;

    li {
      list-style-type: none;
      margin: 5px 20px;
      font-size: larger;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;
